import { TransportOrderIdView } from '../../../../models';

export class TransportOrderOverviewLoad {
  public static readonly type = '[TransportOrderOverview] Load Overview';
  constructor(public payload: TransportOrderIdView) {}
}

export class TransportOrderOverviewSetInitialState {
  public static readonly type = '[TransportOrderOverview] Set Initial State';
}
